import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import React, { useCallback, useEffect, useState, useContext } from 'react'
import axios from 'axios';
import { LoadingContext } from "../../context/LoadingContext";
import Swal from 'sweetalert2'
const config = require('../../config.json')

export default function Investbuy({ ipAddress, loginData }) {
    const [loading, setLoading] = useContext(LoadingContext);
    const [data, setData] = useState('')
    const [bal, setBal] = useState(0)

    const handlebuypack = (amt, pid) => {
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid,
            "amt": amt,
            "pack": pid,
        });
        Swal.fire('AK Herbal', "Please wait for geting Information", 'info')
        setLoading(true)
        console.log(data)
        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}/invest`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(axiosConfig)
            .then((response) => {
                setLoading(false)
                console.log(response.data);
                let res = response.data;
                Swal.fire({
                    title: "AK Herbal",
                    icon: 'info',
                    text: res?.message
                })
                handleCall()
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleCall = useCallback(() => {

        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}packages`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(axiosConfig)
            .then((response) => {
                setData(response.data?.info)
                setBal(response.data?.info?.topup)
                console.log(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [ipAddress, loginData.auth, loginData.token, loginData.ulid])
    useEffect(() => {
        handleCall()
    }, [handleCall])

    const handleValues = async (e, p) => {
        if (bal >= parseFloat(e) && bal > 0) {
            Swal.fire({
                title: "AK Herbal",
                icon: 'info',
                text: "Do you Want to Invest Amount " + e
            }).then((res) => {
                if (res.isConfirmed) {
                    handlebuypack(e, p)
                }
            })
        }
        else {
            Swal.fire("AK Herbal", "Please Check You Topup Wallet. Your Balance :" + bal, "info");
        }
    }
    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y pt-2 mb-4">
                            <div>
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 text-center text-black ">Buys Investment Package</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2" key="n2">
                                        <div className="card">
                                            <div className="card-body dashinc">
                                                <div className="d-flex justify-content-between">
                                                    <div className="card-info">
                                                        <p className="card-text m-0 text-black text-sm">Topup Wallet Balance </p>
                                                        <div className="d-flex align-items-end mb-2">
                                                            <small className="text-black "><i className='bx bx-rupee bx-xs'></i>  {data?.topup}  </small>
                                                        </div>
                                                    </div>
                                                    <div className="card-icon">
                                                        <span className="badge bg-label-success rounded p-2">
                                                            <i className='bx bx-rupee bx-sm'></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    {data?.investPack?.map((list, i) => {
                                        return (
                                            <>
                                                <div className="col-md-6  mb-2" id={i + 1} key={i + 1099}>
                                                    <div className="card">
                                                        <div className="card-body dashinc">
                                                            <h6 className='text-black text-center'>{list.name}</h6>
                                                            <p className="card-text m-0 text-black text-sm text-center mb-2">{list.package_info} </p>
                                                            <div className="d-flex justify-content-between">
                                                                <div className="card-info">
                                                                    <p className="card-text m-0 text-black text-sm"> Amount <i className='bx bx-rupee bx-xs'></i>{list.amount} </p>
                                                                    <div className="d-flex align-items-end mb-2">
                                                                        <small className="text-black text-sm"> ROI Monthely {list.roi}%  </small>
                                                                    </div>
                                                                </div>
                                                                <div className="card-info">

                                                                    <p className="card-text m-0 text-black text-sm"> MAX <i className='bx bx-rupee bx-xs'></i>{parseFloat(list.max) * parseFloat(list.amount)} </p>
                                                                    <div className="d-flex align-items-end mb-2">
                                                                        <small className="text-black text-sm">Monthly <i className='bx bx-rupee bx-xs'></i>{parseFloat(list.amount) * parseFloat(list.roi) / 100}  </small>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="card-info align-items-center mb-2">
                                                                <div className='text-center mt-0'>
                                                                    <button className='btn  btn-success rounded-pill btn-sm' onClick={() => handleValues(list.amount, list.id)}>Buy {list.name} of <i className='bx bx-rupee bx-xs'></i>{list.amount}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 me-2 text-center text-black">Investment</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        data?.invested?.map((list, index) => {
                                            return (
                                                <div className="col-md-4  mb-1" id={index + 1} key={index + 1}>
                                                    <div className="card h-100">
                                                        <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                                            <div className="col-md-12">
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <span className="text-black text-sm">Package Name : {list?.pname}</span>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">Buy Date : {list?.dt}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 text-left'>
                                                                        <small className="text-sm"> Invested Amount :  </small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm"><i className='bx bx-rupee bx-xs'></i> {list?.paid_amount} </small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>

                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}